export default "__VITE_ASSET__CoJ04vC7__"